const DEFAULT_CATEGORIES = [
  { id: 'all', label: 'Semua' },
  { id: 'physical', label: 'Produk Fisik' },
  { id: 'digital', label: 'Digital' },
  { id: 'course', label: 'Kursus' },
  { id: 'membership', label: 'Membership' },
  { id: 'donation', label: 'Donasi' },
  { id: 'ppob', label: 'PPOB' },
];

/** Build visible storefront category tabs from API + optional content checks. */
export function buildStorefrontCategories(store, {
  webinars = [],
  events = [],
  bookingServices = [],
  donationCampaigns = [],
  products = [],
} = {}) {
  if (!store) {
    return [{ id: 'all', label: 'Semua' }];
  }

  const categories = store.storefront_categories?.length
    ? [...store.storefront_categories]
    : [...DEFAULT_CATEGORIES];

  const hasDonationProducts = products.some((p) => p.type === 'donation');
  const hasDonationTab = categories.some((tab) => tab.id === 'donation');
  if (!hasDonationTab && (donationCampaigns.length > 0 || hasDonationProducts)) {
    categories.push({ id: 'donation', label: 'Donasi' });
  }

  return categories.filter((tab) => {
    if (tab.id === 'webinar') return webinars.length > 0;
    if (tab.id === 'event') return events.length > 0;
    if (tab.id === 'booking') return bookingServices.length > 0;
    if (tab.id === 'donation') return donationCampaigns.length > 0 || hasDonationProducts;
    return true;
  });
}
